"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.autopilotPreparingChanges = exports.autopilotPlanStarted = exports.actionMessageAppliedSummaries = exports.actionMessageApplyingSummaries = void 0;
// Messages to show when applying actions from copilot message
exports.actionMessageApplyingSummaries = {
    generic: "Applying changes...",
    rewriteProjectDescription: "Changing project description...",
    rewriteProjectProperties: "Changing project properties...",
    rewriteDesignators: "Changing designators...",
    rewriteComponents: "Changing components...",
    rewriteComponentProperties: "Changing component properties...",
    rewriteLayoutRules: "Changing layout rules...",
    rewriteProjectNets: "Changing net connections...",
    rewriteConnections: "Updating connections...",
    iteratePlacements: "Auto-Layout placements...",
    iterateRouting: "Auto-Layout routing...",
};
exports.actionMessageAppliedSummaries = {
    generic: "Applied changes.",
    empty: "No changes applied.",
};
exports.autopilotPlanStarted = "Started implementing a plan";
exports.autopilotPreparingChanges = "Preparing to make changes...";
//# sourceMappingURL=constants.js.map